<template>
	<b-table
		striped
		hover
		:sticky-header="{ isSimpleCRUD: '250px', middleCRUD: '200px' }"
		responsive
		small
		:fixed="fixed"
		:items="tblItems"
		:fields="tblFields"
		head-variant="dark"
	>
		<template v-if="isLogPage === true" #cell(category)="data">
			<h6 class="category">{{ $t(data.item.category) }}</h6>
		</template>
		<template #cell(actions)="row">
			<k-icon-button v-if="rehomologationButton" @click="$emit('actionRehomologation', row.item.data)">
				<template v-slot:content>
					<b-iconstack font-scale="1">
						<b-icon stacked icon="card-checklist"></b-icon>
						<b-icon stacked icon="exclamation-circle-fill" scale="0.5" shift-h="6" shift-v="-6"></b-icon>
					</b-iconstack>
				</template>
			</k-icon-button>
			<k-icon-button
				v-if="viewButton"
				icon="eye"
				@click="$emit('actionView', row.item.data)"
				:textTooltip="$t('buttons.view')"
			/>
			<k-icon-button
				v-if="editButton"
				:textTooltip="$t('buttons.edit')"
				:disabled="isEditDisabled"
				icon="pencil"
				@click="$emit('actionEditar', row.item.data)"
			/>
			<k-eraser-button
				v-if="excludeButton"
				:disabled="isDeleteDisabled"
				@click="$emit('actionExcluir', row.item.data)"
				:textTooltip="$t('buttons.erase')"
			/>
			<k-icon-button
				v-if="addButton"
				icon="plus"
				:disabled="!userPermissions.create"
				variant="outline-info"
				@click="$emit('actionAdicionar', row.item.data)"
			/>
			<k-icon-button
				v-if="inactiveButton"
				icon="slash-circle"
				:disabled="!userPermissions.delete"
				variant="outline-danger"
				@click="$emit('actionInativar', row.item.data)"
			/>
		</template>

		<template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
			<slot :name="slot" v-bind="scope" />
		</template>

		<template #cell(permissions)="data" v-if="checkBoxOptions">
			<div class="checkboxInline">
				<b-form-group>
					<k-checkbox-group
						:isActive="true"
						:options="tblItems[data.index].data.permissions"
						type="checkbox"
						:errors="{}"
						v-model="userPermissionsObject[tblItems[data.index].data.routeName]"
					/>
				</b-form-group>
			</div>
		</template>
	</b-table>
</template>

<script>
import KIconButton from "./Buttons/KIconButton.vue";
import KEraserButton from "./Buttons/KEraserButton.vue";
import ModalMixin from "@/mixins/ModalMixin";
import KCheckboxGroup from "./FormComponents/KCheckboxGroup.vue";
import { mapGetters } from "vuex";

export default {
	components: { KIconButton, KCheckboxGroup, KEraserButton },
	mixins: [ModalMixin],
	props: {
		items: {
			type: Array,
			required: true
		},
		fields: {
			type: Array,
			default: () => [],
			required: true
		},
		checkBoxOptions: {
			type: Boolean,
			default: false
		},
		editPermission: {
			type: Boolean,
			default: false
		},
		includePermission: {
			type: Boolean,
			default: false
		},
		inactivePermission: {
			type: Boolean,
			default: false
		},
		editButton: {
			type: Boolean,
			default: false
		},
		rehomologationButton: {
			type: Boolean,
			default: false
		},
		excludeButton: {
			type: Boolean,
			default: false
		},
		addButton: {
			type: Boolean,
			default: false
		},
		userPermissionsObject: {
			type: Object
		},
		isSimpleCRUD: {
			type: Boolean,
			default: false
		},
		middleCRUD: {
			type: Boolean,
			default: false
		},
		inactiveButton: {
			type: Boolean,
			default: false
		},
		viewButton: {
			type: Boolean,
			default: false
		},
		fixed: {
			type: Boolean,
			default: false
		},
		overridePermissions: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters(["userPermissions"]),
		isEditDisabled() {
			if (this.overridePermissions) {
				return false;
			}
			return !this.userPermissions.update;
		},

		isDeleteDisabled() {
			if (this.overridePermissions) {
				return false;
			}
			return !this.userPermissions.delete;
		},
		tblItems: function () {
			let response = [];

			this.items.forEach((item) => {
				let obj = {};

				this.fields.forEach((field) => {
					if (field.getProp) {
						obj[field.key] = field.getProp(item, this.$store.state);
					} else obj[field.key] = item[field.key];
				});

				obj["data"] = item;
				response.push(obj);
			});
			return response;
		},
		tblFields: function () {
			return [...this.fields, { key: "actions", label: "", class: "text-right" }];
		},
		isLogPage() {
			return this.$route.name.includes("log");
		}
	}
};
</script>

<style scoped>
.checkboxInline {
	display: inline-flex;
}
.fullHeight {
	max-height: calc(100% - 250px);
}
.middleHeight {
	max-height: 38%;
}
.custom-checkbox .custom-control-label::before {
	top: 0px;
}
.checkIcon {
	background-image: url("../../assets/img/Eraser.svg");
	background-repeat: no-repeat;
	background-position: center;
}
.category {
	max-width: 80px;
	margin-top: 1vh;
}
</style>
